export default function IconLink({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M3 4.88989V4.13989H2.25V4.88989H3ZM21 4.88989H21.75V4.13989H21V4.88989ZM21 19.1099V19.8599H21.75V19.1099H21ZM3 19.1099H2.25V19.8599H3V19.1099ZM11.9 12.3699L11.4175 12.944C11.6941 13.1765 12.0971 13.1787 12.3762 12.9493L11.9 12.3699ZM3 4.88989V5.63989H21V4.88989V4.13989H3V4.88989ZM21 4.88989H20.25V19.1099H21H21.75V4.88989H21ZM21 19.1099V18.3599H3V19.1099V19.8599H21V19.1099ZM3 19.1099H3.75V4.88989H3H2.25V19.1099H3ZM3 4.88989L2.51745 5.46404L11.4175 12.944L11.9 12.3699L12.3825 11.7957L3.48255 4.31574L3 4.88989ZM11.9 12.3699L12.3762 12.9493L21.4762 5.46928L21 4.88989L20.5238 4.3105L11.4238 11.7905L11.9 12.3699Z"
        fill="currentColor"
      />
    </svg>
  );
}
